module.exports = __webpack_public_path__ + "img/team.f176fff3.svg";